<template>
  <div>
    <el-dialog :title="checkedTrackCodes.type === 'pay' ? 'Төлбөр төлөх' : checkedTrackCodes.type === 'payAndGive' ? 'Төлбөр төлөх | хэрэглэгчид олгох' : checkedTrackCodes.type === 'payAndDelivery' ? 'Төлбөр төлөх | хүргэлтэнд гаргах' : ''" :visible.sync="this.$root.progressDialog" :before-close="handleClose" width="350px" center>
      <el-row>
        <el-col v-if="message" style="color: red;">
          {{ message }}
        </el-col>
        <el-col class="m-b-10 m-t-10">
          Таны сонгосон трак код<br>
          <el-tag v-for="item in track_code" :key="item" class="m-r-5 m-b-10">{{ item }}</el-tag>
          <hr>
        </el-col>
        <el-col class="m-b-10">
          <div v-if="countTrackCode" class="m-b-10">Нийт тоо: {{ countTrackCode }}</div>
          <div>Ачааны төлбөр: {{ totalAmount | formatCurrency() }}</div>
          <div v-if="coupon_price && !message_coupon">Купон төлбөр: {{ coupon_price | formatCurrency() }}</div>
          <div v-if="delivery">Хүргэлтийн төлбөр: {{ delivery | formatCurrency() }}</div>
          <div v-if="save_price">Хадгалалтын төлбөр: {{ save_price | formatCurrency() }}</div>
          <div><b>Төлөх төлбөр:</b> {{ save_price + delivery + totalAmount - coupon_price | formatCurrency() }}</div>
          <!-- <div v-if="totalAmount && paid_type !== 'cupon' && !message_coupon"><b>Төлөх төлбөр:</b> {{ save_price + delivery + totalAmount - coupon_price | formatCurrency() }}</div> -->
          <div v-if="paid_type === 'cupon'" class="red_text"><b>Төлөх төлбөр:</b> {{ 0 | formatCurrency() }}</div>
          <div v-if="jin"><b>Ачааны жин:</b> {{ jin }}гр</div>
          <hr>
        </el-col>
        <el-col class="m-b-10" v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
          Тавиурын код:
          <div v-if="checkedTrackCodes.taviur_codes">
            <span v-for="(item, index) in checkedTrackCodes.taviur_codes" :key="index" class="m-b-10">
              {{ item }}, &nbsp;
            </span>
          </div>
          Утасны дугаар
          <div v-if="phone_number_json">
              {{ phone_number_json }}, &nbsp;
          </div>
          <div class="m-t-10" v-if="description">
            Тайлбар: {{ description }}
          </div>
          <hr>
        </el-col>
        <!-- tulbur -->
         <el-col class="m-b-10 m-t-10">
          <el-tag v-if="checkedTrackCodes.is_paid === true" type="success">Төлбөр төлсөн</el-tag>
         </el-col>
          <el-col v-if="not_paid_track_codes.length" class="m-b-10">
            <div class="m-b-10">Төлбөр төлөөгүй трак код: </div>
            <el-tag v-for="item, index in not_paid_track_codes" :key="index" type="danger">{{ item.track_code }}</el-tag>
         </el-col>
         <hr>
        <el-col v-if="checkedTrackCodes.is_paid === false || not_paid_track_codes.length" class="m-b-10">
          <div>
            <div v-if="checkPermissionsPage('admin')">
              <el-switch v-model="is_paid" active-color="#13ce66" inactive-color="#ff4949" active-text="Төлөх" :active-value="true" :inactive-value="false" class="m-b-10">
              </el-switch><br>
            </div>
            <div v-if="is_paid === true" class="m-b-10">
              <div class="m-b-10">
              <el-button size="small" @click="valueTransaction('cash')">Бэлэн төлөлт</el-button>
              </div>
              <div class="m-b-10">
                <el-button size="small" @click="valueTransaction('transaction')">Шилжүүлэг</el-button>
              </div>
              <div class="m-b-10">
                <el-button size="small" @click="valueTransaction('card')">Карт</el-button>
              </div>
              <div class="m-b-10">
                <el-button size="small" @click="valueTransaction('notpay')">Төлбөр төлөхгүй</el-button>
              </div>
              <div class="m-b-10" v-if="user_status === 'new'">
                <el-button v-if="countTrackCode === 1 || !countTrackCode" size="small" @click="valueTransaction('cupon')">Купон</el-button>
              </div>
              <el-select v-if="cuponList.length" v-model="cupon_id" placeholder="Купон сонгоно уу">
                <el-option v-for="(item, index) in cuponList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <!-- hvrgelt -->
        <el-col>
          <el-row>
            <el-col v-if="this.address_detail" class="m-b-10">
              <u>Хүргүүлэх хаяг:</u><br>
              <span style="color: grey;">{{ this.address_detail }}</span>
            </el-col>
            <el-col class="m-b-10" v-if="hvrgeltiin_ajiltan">
              <el-tag type="warning">Хүргэлтийн ажилтан сонгосон : {{ hvrgeltiin_ajiltan }}</el-tag>
            </el-col>
            <el-col class="m-b-10" v-if="!hvrgeltiin_ajiltan">
              <el-tag type="info">Хүргэлтийн ажилтан сонгоогүй </el-tag>
            </el-col>
            <el-col :span="24">
              Хүргэлтийн ажилтан
              <el-select v-model="driver_id" placeholder="Хүргэлтийн ажилтан сонгох" class="m-b-20">
                <el-option v-for="item, index in workersList" :key="index" :label="item.lastName" :value="item.id" class="m-t-10 w-100">{{ item.lastName }}</el-option>
              </el-select><br><br>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="m-t-20">
          <div v-if="checkPermissionsPage('admin')">
            <el-button class="w-100" type="primary" size="mini" @click="progressChange(null)">Төлбөр төлөх</el-button>
            <!-- <el-button v-if="checkedTrackCodes.is_paid === false || not_paid_track_codes.length" class="w-100" type="primary" size="mini" @click="progressChange(null)">Төлбөр төлөх</el-button> -->
          </div>
          <div class="m-t-10" v-if="checkPermissionsPage('admin')">
            <el-button class="w-100" type="success" size="mini" @click="progressChange(200)">Төлбөр төлөх | хэрэглэгчид олгох</el-button>
            <!-- <el-button v-if="checkedTrackCodes.is_paid === false" class="w-100" type="success" size="mini" @click="progressChange(200)">Төлбөр төлөх | хэрэглэгчид олгох</el-button> -->
          </div>
          <div class="m-t-10" v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
            <el-button class="w-100" type="success" size="mini" @click="progressChange(200)">Хэрэглэгчид олгох</el-button>
            <!-- <el-button v-if="checkedTrackCodes.type === 'give' || checkedTrackCodes.type === 'one'" class="w-100" type="success" size="mini" @click="progressChange(200)">Хэрэглэгчид олгох</el-button> -->
          </div>
          <!-- <div class="m-t-10" v-if="checkPermissionsPage('admin')">
            <el-button v-if="checkedTrackCodes.is_paid === false" class="w-100" type="warning" size="mini" @click="progressChange(130)">Төлбөр төлөх | хүргэлтэнд гаргах</el-button>
          </div> -->
          <div class="m-t-10" v-if="checkPermissionsPage('admin') || checkPermissionsPage('mongolia_branch')">
            <el-button v-if="this.address_id && this.is_paid === true" class="w-100" type="warning" size="mini" @click="progressChange(130)">Хүргэлтэнд гаргах</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import services from '@/helpers/services'
import { checkPermissions } from '@/helpers/custom'
import _ from 'lodash'

export default {
  name: 'ProgressDialog',
  data () {
    return {
      progress_code: null,
      track_code: [],
      addressList: {
        Address: []
      },
      address_id: null,
      is_paid: null,
      paid_type: null,
      type: '',
      totalAmount: 0,
      delivery: 0,
      countTrackCode: 0,
      description: '',
      not_paid_track_codes: [],
      address: null,
      deliveries: null,
      no: '',
      workersList: [],
      driver_id: null,
      hvrgeltiin_ajiltan: null,
      address_detail: null,
      cuponList: [],
      cupon_id: null,
      jin: null,
      user_status: null,
      coupon_price: 0,
      phone_number: [],
      phone_number_json: null,
      message: null,
      coupon_track_code: null,
      message_coupon: 0,
      save_price: 0
    }
  },
  props: {
    checkedTrackCodes: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    uniqueUsers () {
      return this.addressList || []
    }
  },
  watch: {
    checkedTrackCodes: {
      handler (newVal) {
        if (newVal) {
          this.is_paid = newVal.is_paid || false
          this.paid_type = newVal.paid_type || ''
          this.user_status = newVal.user_status || ''
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.getAllWorkers()
    this.initData()
    this.processNumbers()
    this.calculateCouponPrice()
  },
  methods: {
    processNumbers () {
    // Дугаарыг групплээд JSON форматад хөрвүүлэх
      const grouped = _.groupBy(this.phone_number, phone => phone)

      // Давхардсан дугаар шалгах
      const uniqueNumbers = Object.keys(grouped)
      if (uniqueNumbers.length > 1) {
        this.message = 'Олон дугаартай трак код сонгосон байна. Та нэг дугаартай олон трак код сонгох боломжтой'
      }

      // ✅ `phoneNumber: "95618113"` форматтай болгох
      this.phone_number_json = uniqueNumbers[0]
    },
    async calculateCouponPrice () {
      try {
        const paylod = { track_codes: this.track_code, phone_number: this.phone_number_json }
        services.calculateCuoponPrice(paylod)
          .then(response => {
            if (response) {
              this.coupon_price = response.data || 0
              this.message_coupon = response.message
              this.coupon_track_code = response.track_code
            }
          }).catch((err) => {
            console.log(err)
            alert(err)
          })
      } catch (error) {
        this.$notify({
          title: 'Амжилтгүй',
          message: 'Алдаа. ' + error,
          type: 'error'
        })
      }
    },
    initData () {
      const c = this.checkedTrackCodes
      this.track_code = c.selectedTrackCodes || []
      this.is_paid = c.is_paid
      this.type = c.type
      this.totalAmount = c.totalPrice || 0
      this.save_price = c.save_price || 0
      this.delivery = c.deliveryAmount || 0
      this.countTrackCode = c.countTrackCode || 0
      this.description = c.description || ''
      this.not_paid_track_codes = c.not_paid_track_codes || []
      this.address_id = c?.address_id || null
      this.deliveries = c.deliveries || null
      this.no = c.no || ''
      this.driver_id = c?.driver_id || null
      this.hvrgeltiin_ajiltan = c?.hvrgeltiin_ajiltan || null
      this.address_detail = c?.address_detail || null
      this.jin = c.jin || 0
      this.user_status = c.user_status || null
      this.phone_number = c.phone_number || []
    },
    playAudio () {
      const audio = new Audio(
        'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com/success.MP3')
      audio.play()
    },
    valueTransaction (data) {
      this.paid_type = data
      if (this.paid_type === 'cupon') {
        services.getAllCupon()
          .then((response) => {
            if (response) {
              this.cuponList = response.data
            } else {
              this.$notify({
                title: 'Алдаа',
                message: 'Купоны мэдээлэл татхад алдаа гарлаа.',
                type: 'danger',
                duration: 3000
              })
            }
          })
        this.totalAmount = 0
      }
    },
    handleClose () {
      this.delivery = 0
      this.totalPrice = 0
      this.countTrackCode = 0
      this.track_code = []
      this.is_paid = null
      this.type = null
      this.totalAmount = 0
      this.save_price = 0
      this.description = ''
      this.not_paid_track_codes = []
      this.address_id = null
      this.deliveries = null
      this.no = ''
      this.driver_id = null
      this.hvrgeltiin_ajiltan = null
      this.address_detail = null
      this.cupon_id = null
      this.paid_type = null
      this.$root.progressDialog = false
    },
    progressChange (data) {
      if (this.not_paid_track_codes.length) {
        this.track_code = this.not_paid_track_codes
          .filter(item => item.is_paid === 0 || item.is_paid === false)
          .map(item => item.track_code)
      }
      if (!this.track_code.length) {
        this.$notify({
          title: 'Анхааруулга',
          message: 'Та трак код сонгоогүй байна.',
          type: 'warning',
          position: 'top-left'
        })
        return
      }

      if (!this.is_paid && data === null) {
        this.$notify({
          title: 'Анхааруулга',
          message: 'Та төлбөр төлсөн болгоно уу.',
          type: 'warning',
          position: 'top-left'
        })
        return
      }

      this.$alert('Та төлөв өөрчлөхдөө итгэлтэй байна уу?', 'Анхааруулга', {
        confirmButtonText: 'Тийм',
        cancelButtonText: 'Үгүй',
        type: 'warning'
      }).then(() => {
        this.$root.fullscreenLoading = true
        this.progress_code = data

        const payload = {
          is_paid: this.is_paid,
          track_code: this.track_code,
          paid_type: this.paid_type,
          progress_code: this.progress_code,
          address_id: this.address_id,
          deliveries: this.deliveries ? { id: this.deliveries.id, status: this.deliveries.status, driver_id: this.deliveries.driver_id } : null,
          delivery_price: this.delivery,
          driver_id: this.driver_id,
          cupon_id: this.cupon_id,
          coupon_track_code: this.coupon_track_code
        }

        services.progressChange(payload)
          .then((response) => {
            this.$root.progressDialog = false
            this.$root.fullscreenLoading = false
            this.$notify({
              title: 'Амжилттай',
              message: 'Төлөв амжилттай өөрчлөгдлөө.',
              type: 'success',
              position: 'top-left'
            })

            if (!data || ['payAndDelivery', 'payAndGive'].includes(this.checkedTrackCodes.type)) {
              this.playAudio()
            }

            this.is_paid = response.data.is_paid
            this.$root.deliveryDetailDialog = false
            this.$root.progressDialog = false
            this.$emit('refreshData')
          })
          .catch((error) => {
            this.$root.fullscreenLoading = false
            console.error('Алдаа гарлаа:', error)
            this.$notify({
              title: 'Алдаа',
              message: 'Төлөв солих үед алдаа гарлаа.',
              type: 'error',
              position: 'top-left'
            })
          })
      }).catch(() => {
        console.warn('Хэрэглэгч баталгаажуулаагүй.')
        this.is_paid = false
        this.$root.fullscreenLoading = false
      })
    },
    openAddressDialog () {
      this.$root.addAddressDialog = true
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    getAllWorkers () {
      this.$root.fullscreenLoading = true
      services.getAllWorkers()
        .then(response => {
          if (response.type === 'success') {
            this.workersList = response.data
          }
          this.$root.fullscreenLoading = false
        }).catch((err) => {
          console.log(err)
          alert(err)
          this.$root.fullscreenLoading = false
        })
    }
  }
}
</script>

<style>
.m-b-10 {
  margin-bottom: 10px;
}
.m-r-5 {
  margin-right: 5px
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-t-10 {
  margin-top: 20px;
}
</style>
